import { trackImage } from 'assets';
import Image from 'next/image';
import React from 'react';

const Track = () => {
  return (
    <div className='w-full h-full bg-dropDownMenuBg rounded-3xl p-6 flex-col flex gap-6 justify-between'>
      <Image
        className='w-full '
        alt='trackImage'
        width={340}
        height={140}
        src={trackImage}
      />
      <div className='flex flex-col gap-2'>
        <p className='text-lg leading-[26px] font-semibold text-white text-start'>
          Track your Progress
        </p>
        <p className='text-sm font-normal leading-[22px] text-grayZl-600 text-start'>
          Visualize your growth. Every small step counts here, building lasting
          change.
        </p>
      </div>
    </div>
  );
};

export default Track;
